import { API_HOST, API_PREFIX, ENV, BACKEND_API_HOST, REGION, AFTX_DOMAIN } from 'src/core/config/APIConstants';

export const getEnv = ( host: string = window.location.host ): ENV =>
{
    if ( !host || host === 'localhost' || host.includes( 'local.' ) ) return ENV.DEVELOPMENT;
    else if ( host.includes( '.integ.aftx.amazonoperations.app' ) ) return ENV.BETA;
    else if ( host.includes( '.aftx.amazonoperations.app' ) ) return ENV.PRODUCTION;
    else if ( host.startsWith( 'dev.' ) ) return ENV.GAMMA;
    else if ( host.startsWith( 'beta.' ) ) return ENV.BETA;
    else if ( host.startsWith( 'gamma.' ) ) return ENV.GAMMA;
    else if ( host.startsWith( 'prod.' ) ) return ENV.PRODUCTION;
    else return ENV.DEVELOPMENT;
};

export const getRegion = ( host: string = window.location.host, env: ENV ): REGION =>
{
    if ( env === ENV.DEVELOPMENT || env === ENV.BETA )
    {
        return REGION.TEST;
    }
    else if ( host.includes( 'na.' ) )
    {
        return REGION.NA;
    }
    else if ( host.includes( 'eu.' ) )
    {
        return REGION.EU;
    }
    else if ( host.includes( 'zaz.' ) )
    {
        return REGION.ZAZ;
    }
    else if ( host.includes( 'nrt.' ) || host.includes( 'fe.' ) )
    {
        return REGION.NRT;
    }
    else return REGION.TEST;
};

export const getOrigin = ( location: Location = window.location ): string =>
{
    return location.origin;
};
export const getAPIHost = ( location: Location = window.location ): string =>
{
    const env = getEnv( location.host );
    const region = getRegion( location.host, env );
    const host = API_HOST[ env ][ region ];
    if ( !host ) throw new Error( `Api host not found for environment: ${env}` );

    return host;
};
export const getBackendAPIHost = ( location: Location = window.location ): string =>
{
    const env = getEnv( location.host );
    const region = getRegion( location.host, env );
    const host = BACKEND_API_HOST[ env ][ region ];
    if ( !host ) throw new Error( `Api host not found for environment: ${env}` );

    return host;
};

/**
 * Returns the API host with the API prefix
 *
 * @param {Location} location A location object
 * @returns {string} Returns the API host & prefix based on the current env
 */
export const getAPIHostWithPrefix = ( location: Location = window.location ): string =>
{
    const apiHost = getAPIHost( location );
    return `${apiHost}${API_PREFIX}`;
};

export const getBackendAPIHostWithPrefix = ( location: Location = window.location ): string =>
{
    const apiHost = getBackendAPIHost( location );
    return `${apiHost}${API_PREFIX}`;
};

export const getAftxDomain = ( location: Location = window.location ): string =>
{
    const env = getEnv( location.host );
    const region = getRegion( location.host, env );
    const host = AFTX_DOMAIN[ env ][ region ];
    if ( !host ) throw new Error( `Api host not found for environment: ${env}` );

    return host;
};
